
import React from "react"
import {isFunction, isString} from "lodash"
import PropTypes from "prop-types"

import {isPromise} from "@irati/utils/promise"
import History from "@irati/utils/history"

export const withHandleAction = (WrappedComponent) => {
  return class extends React.Component {
    static contextTypes = {
      appPath: PropTypes.string.isRequired
    }

    static propTypes = {
      item: PropTypes.shape({
        action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
        label: PropTypes.string.isRequired
      })
    }

    constructor(props) {
      super(props)
      this.state = {
        load: {}
      }
    }

    handleAction = (e) => {
      e.preventDefault()
      const {action} = this.props.item
      if (isString(action)) return History.push(action, this.context)
      if (isFunction(action)) {
        const load = action()
        if (isPromise(load)) this.setState({load})
      }
    }

    render() {
      return <WrappedComponent {...this.props} onClick={this.handleAction} load={this.state.load} />
    }
  }
}
